import { SectionShowView } from '../types/sections';
import { MainV3ApiBase } from './base';
import { SectionId } from '../../commonv3/types/sections';
import { SectionEventType } from '../../commonv3/types/section_events';

export const SectionEventApis = {
    base() {
        return MainV3ApiBase.appendPath('/users/current/section_events');
    },
    create(sectionId: SectionId, eventType: SectionEventType): Promise<SectionShowView> {
        return this.base().post({ section_id: sectionId, event_type: eventType });
    },
};
